define('app-MultipleItineraries/settings',[],function () {
    return {
        itineraryPicker: '#selectedItinerary',
        itineraryContent: '#itineraryContent',
        itineraryModalPrint: '#itineraryModalPrint',
        itineraryModal: '#itineraryModal',
        viewFullItinerary: '#viewFullItinerary'
    };
});
